import React from 'react';

const useRefocusOnBlur = (disabled = false) => {
  return React.useMemo(() => {
    return disabled ? void 0 : (e) => {
      e.preventDefault();
      setTimeout(() => {
        e.target.focus();
      }, 0);
    };
  }, [
    disabled
  ]);
};

export { useRefocusOnBlur };
//# sourceMappingURL=useRefocusOnBlur.js.map
